import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비등록 > 데이터베이스] 관리대상 리스트 목록을 가지고 온다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getDatabaseList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-dbms/get-database-list.do`, params);
  },
  /**
   * [장비등록 > 데이터베이스] 관리대상 등록 화면의 최근 등록장비 갯수를 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getRecentRegisteredDatabaseCount() {
    return axios.get(`${baseUrl}/settings/device-registration-dbms/get-recent-registered-database-count.do`);
  },
  /**
   * [장비등록 > 데이터베이스] 관리대상 등록 화면의 데이터베이스 정보를 수정한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateDatabaseList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-dbms/update-database-list.do`, params);
  },
  /**
   * [장비등록 > 데이터베이스] 관리대상 등록 화면의 데이터베이스 정보를 삭제한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteDatabaseList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-dbms/delete-database-list.do`, params);
  },
  /**
   * [장비등록 > 데이터베이스] 관리대상 등록 화면의 데이터베이스 정보를 삭제한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  insertDatabase(params) {
    return axios.post(`${baseUrl}/settings/device-registration-dbms/insert-database.do`, params);
  },
  /**
   * [장비등록 > 데이터베이스] 관리대상 등록 화면의 데이터베이스 연결 테스트를 수행한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  connectionDbTest(params) {
    return axios.post(`${baseUrl}/settings/device-registration-dbms/connection-db-test.do`, params);
  },
  /**
   * DB 기본 포트 목록을 조회한다.
   * @author Ju
   * @return {[type]} [description]
   */
  getDbPortList() {
    return axios.get(`${baseUrl}/common/basicinfo/get-basicinfo-set-list.do`, { params: { basicinfoId: 'DBMSPORT' } });
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-dbms.js